
import ReoAuthSDK from '@reolink/reo-auth-sdk';

const isProduction = process.env.NODE_ENV === 'production' && process.env.CLOUD_ENV === 'production';
const isTest = process.env.CLOUD_ENV === 'test';
const isDev = process.env.CLOUD_ENV === 'develop';

let domain;
if ( isProduction ) {

    domain = 'reolink.com.cn';

} else if ( isTest ) {

    domain = '.sandbox.reolink.com.cn';

} else if ( isDev ) {

    domain = '.develop.reolink.com.cn';

} else {

    domain = '.develop.reolink.com.cn';

}

export const authSdk = new ReoAuthSDK( domain );



// WEBPACK FOOTER //
// ./src/api/authSdk.js